import { useEffect } from "react";
import { useParams, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isSupportedLang, SUPPORTED_LANGS } from "@/i18n";

/**
 * Wrapper route that reads /:lang from the URL and syncs i18n.
 * If /:lang is missing or invalid, redirects to /fr/...
 */
const LangRouter = () => {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang && isSupportedLang(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);

  // If lang param is not a supported language, redirect
  if (!lang || !isSupportedLang(lang)) {
    // This shouldn't happen with proper route setup, but just in case
    return null;
  }

  return <Outlet />;
};

export default LangRouter;
